import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpEvent,
  HttpRequest,
  HttpHandler,
  HttpResponse,
  HttpErrorResponse,
  HttpClient,
} from '@angular/common/http';
import {
  Observable,
  catchError,
  finalize,
  first,
  map,
  switchMap,
  tap,
  throwError,
} from 'rxjs';
import { LoaderService } from '../loader/loader.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { CommonService } from '../common-services/common.service';
import { logOut, removeKeys } from 'src/app/shared/utils';

const authService = 'auth-service';
const urlsExceptions: string[] = [
  `${authService}/auth/retrieveOtp`,
  `${authService}/auth/sendWelcomeMail`,
  `${authService}/confirmUser`,
  `${authService}/login`,
  `${authService}/sendOtp`,
  `${authService}/sendResetPasswordMail`,
  `${authService}/signUp`,
  `${authService}/sso/generateToken`,
  `${authService}/sso/login`,
  `${authService}/uploadDocuments`,
  `${authService}/user-management/getUserDetailByEmail`,
  `${authService}/verifyOtp`,
  `${authService}/verifyuuid`,
  `${authService}/resetPassword`,
  'customer/lead-management/createCorporateCustomerDeal',
  'supplier/lead-management/createCorporateSupplierDeal',
];

const urlsExceptionForLoader: string[] = [`chat-Library`];
@Injectable()
export class Interceptor implements HttpInterceptor {
  base_url = environment.BASE_URL;
  private httpCount = 0;
  private isError401 = false;
  constructor(
    private loader: LoaderService,
    private router: Router,
    private toastr: ToastrService,
    private commonService: CommonService,
    private http: HttpClient,
  ) {}

  intercept(
    httpRequest: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    const startTime = Date.now();
    let status: string;
    let excludeLoader = false;

    for (let index = 0; index < urlsExceptionForLoader.length; index++) {
      if (httpRequest.url.includes(urlsExceptionForLoader[index])) {
        excludeLoader = true;
      }
    }
    if (this.httpCount === 0 && !excludeLoader) {
      this.loader.show();
    }
    var includeToken = true; // this variable exculde implementation of token in header from certain list of API's
    for (let urlIndex = 0; urlIndex < urlsExceptions.length; urlIndex++) {
      if (
        !httpRequest.url.includes(this.base_url) ||
        httpRequest.url.includes(urlsExceptions[urlIndex])
      ) {
        includeToken = false;
        break;
      }
    }

    // const customerToken = sessionStorage.getItem('customerToken');
    // const supplierToken = sessionStorage.getItem('supplierToken');
    // const internalToken = sessionStorage.getItem('internalToken');
    let token = sessionStorage.getItem('customerToken');
    // let entity = this.router.url.includes('shop')
    //   ? 'shop'
    //   : this.router.url.split('/')[1];
    // if (entity === 'customer' || entity === 'shop') {
    //   token = customerToken;
    // } else if (entity === 'supplier') {
    //   token = supplierToken;
    // } else if (entity === 'internal') {
    //   token = internalToken;
    // }
    this.httpCount++;
    let request: any;
    if (this.isError401) {
      // If a 401 error has already been encountered, block the request
      return throwError('401 response detected, blocking further requests');
    }
    if (includeToken) {
      request = httpRequest.clone({
        setHeaders: {
          'X-Auth': `Bearer ${token}`,
          'Content-Type': 'application/json',
          'X-Role': 'Customer'
          //'X-Role': this.commonService.userRoleKey,
        },
      });
    } else {
      // excepted the append token for s3 upload files
      request = httpRequest.clone();
    }

    return next.handle(request).pipe(
      tap(
        (event) => {
          if (event instanceof HttpResponse) {
            status = 'succeeded';
          }
        },
        (error) => (status = 'failed'),
      ),
      catchError((error: HttpErrorResponse) => {
        console.log(error.status, "Error Status");
        
        if (error.status === 401) {
          if (!this.isError401) {
           // this.toastr.error(error?.error?.message);
          }
          this.isError401 = true;
          // Token expired, redirect to login page
          //this.router.navigate(['/']);
          sessionStorage.clear();
          this.router.navigate(['/']);
          //removeKeys(entity, this.router);
          // this.handle401Error(request, next, entity);
        }
        return throwError(error);
      }),
      finalize(() => {
        this.httpCount--;
        if (this.httpCount === 0) {
          this.loader.hide();
        }

        // logger info
        const endTime = Date.now();
        const elapsedTime = endTime - startTime;
        const message = `${request.method} ${request.urlWithParams} ${status} in ${elapsedTime} ms`;
        this.logDetails(message);
      }),
    );
  }

  private logDetails(msg: string) {
    console.info(msg);
  }

  private handle401Error(request: HttpRequest<any>, next: HttpHandler) {
    const module = 'customerRefreshToken';
    const token = sessionStorage.getItem(module);

    if (token) {
      return this.refreshToken(token).pipe(
        switchMap((token: any) => {
          sessionStorage.setItem(module, token);
          return next.handle(this.addTokenHeader(request, token.accessToken));
        }),
        catchError((err) => {
          sessionStorage.clear();
          //removeKeys(entity, this.router);
          return throwError(err);
        }),
      );
    }

    return true;
    // return this.refreshTokenSubject.pipe(
    //   filter(token => token !== null),
    //   take(1),
    //   switchMap((token) => next.handle(this.addTokenHeader(request, token)))
    // );
  }

  private addTokenHeader(request: HttpRequest<any>, token: string) {
    /* for Spring Boot back-end */
    return request.clone({ headers: request.headers.set('X-Auth', 'Bearer ' + token) });
  }

  refreshToken(token: string) {
    const AUTH_API = '';
    return this.http.post(AUTH_API + 'refreshtoken', {
      refreshToken: token,
    });
  }

  // public getRefreshToken(): string | null {
  //   return window.sessionStorage.getItem(REFRESHTOKEN_KEY);
  // }
}
